import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "fileField", "imagePreview", "output", "button", "input", "imagePreview", "fileName", "fileSize", "deleteButton", "deleteCheckbox", "downloadButton", "error"]

  initialize () {
    let _this = this;

    //File is selected in uploader
    if (_this.hasFileFieldTarget ) {

      _this.fileFieldTarget.onchange = evt => {
        var file = _this.fileFieldTarget.files[0];
        if (file == null) return;

        const maxBytes = parseInt(_this.fileFieldTarget.dataset.maxBytes || "0", 10);
        const allowedTypes = (_this.fileFieldTarget.accept || "").split(",").filter(Boolean);
        let error = "";
        if (maxBytes > 0 && file.size > maxBytes) error = "Image must be smaller than 5 MB."
        if (allowedTypes.length > 0 && !allowedTypes.includes(file.type)) error = "Choose a PNG or JPEG image."
        if (error.length > 0) {
          _this.fileFieldTarget.value = "";
          if (_this.hasErrorTarget) {
            _this.errorTarget.textContent = error;
            _this.errorTarget.classList.remove("hidden");
          }
          return;
        }
        if (_this.hasErrorTarget) {
          _this.errorTarget.textContent = "";
          _this.errorTarget.classList.add("hidden");
        }

        let fileUrl = URL.createObjectURL(file);
        var name = file.name

        if (_this.hasDeleteCheckboxTarget) {
          _this.deleteCheckboxTarget.checked = false;
        }

        if (_this.hasOutputTarget ) {
          _this.outputTarget.innerHTML = name + " (" + _this.humanFileSize(file.size) + ")";
        }

        if (_this.hasFileNameTarget ) {
          _this.fileNameTarget.innerHTML = name;
          _this.fileNameTarget.classList.remove('hidden');
        }

        if (_this.hasFileSizeTarget ) {
          _this.fileSizeTarget.innerHTML = _this.humanFileSize(file.size);
          _this.fileSizeTarget.classList.remove('hidden');
        }

        if (_this.hasDeleteButtonTarget ) {
          _this.deleteButtonTarget.classList.remove('hidden');
        }

        if (_this.hasImagePreviewTarget && fileUrl != null && fileUrl != undefined) {
          let imagePreview = _this.imagePreviewTarget;

          if (imagePreview.dataset.type == "image") {
            imagePreview.src = fileUrl;
            imagePreview.onload = function() {
              URL.revokeObjectURL(imagePreview.src) // free memory
            }

          } else if (imagePreview.dataset.type == "background") {
            imagePreview.style.backgroundImage = "url('" + fileUrl + "')";
          }

        }

        const form = evt.target.closest("form");
        if (form != null) {
          form.dispatchEvent(new Event("input", { bubbles: true }));
          form.dispatchEvent(new Event("change", { bubbles: true }));
        }

      }
    }

  }

  selectFile(event) {
    event.preventDefault();
    this.fileFieldTarget.click();
  }

  // Delete file action
  deleteFile(event) {
    event.preventDefault();
    let _this = this;

    if (_this.hasDeleteCheckboxTarget) {
      _this.deleteCheckboxTarget.checked = true;
    }

    if (_this.hasFileNameTarget ) {
      _this.fileNameTarget.innerHTML = "";
      _this.fileNameTarget.classList.add('hidden');
    }

    if (_this.hasFileSizeTarget ) {
      _this.fileSizeTarget.innerHTML = "";
      _this.fileSizeTarget.classList.add('hidden');
    }

    if (_this.hasDeleteButtonTarget ) {
      _this.deleteButtonTarget.classList.add('hidden');
    }

    if (_this.hasDownloadButtonTarget ) {
      _this.downloadButtonTarget.classList.add('hidden');
    }

    if (_this.hasImagePreviewTarget ) {
      _this.imagePreviewTarget.style.backgroundImage = "";
    }

  }
  

  humanFileSize(bytes, decimals = 2) {
    if (!bytes || bytes === 0) return '0 KB';

    const k = 1024;
    const sizes = ['KB', 'MB', 'GB', 'TB'];
    let i = -1;
    let size = bytes;

    do {
      size /= k;
      i++;
    } while (size >= k && i < sizes.length - 1);

    return `${parseFloat(size.toFixed(decimals))} ${sizes[i]}`;
  }

  getPreview(event) {
    let imagePreview = this.imagePreviewTarget;
    let fileUrl;
    let file = event.currentTarget.files[0];

    if (this.humanFileSize(file.size) > 10000) {
      alert("The selected image is too large. Please upload an image smaller than 10MB.");
      event.currentTarget.value = null;
    } else {    
      fileUrl = URL.createObjectURL(file);
    
      if (fileUrl != null && fileUrl != undefined) {
        imagePreview.style.backgroundImage = "url('" + fileUrl + "')";
        imagePreview.innerHTML = "";
      }
    }

  }

} 
